import {theme} from 'antd'
import React from 'react'
import compassIcon from 'url:../../../public/assets/images/compass.svg'

export function Compass({rotationAngle}: {rotationAngle: number}) {
  const {
    token: {colorPrimary, colorPrimaryBorder, borderRadiusXS},
  } = theme.useToken()

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        display: 'flex',
      }}
    >
      <img style={{height: '35px', width: '35px'}} src={compassIcon}></img>
    </div>
  )
}
